<template>
	<router-link class="btn btn-icon" :to="to" :title="title">
		<svgicon :name="icon" :fill="false"></svgicon>
	</router-link>
</template>

<script>
export default {
	props: [
		'to',
		'icon',
		'title'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ButtonIcon.vue